import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["status", "button", "buttonText", "locationHeading", "reading", "latitude", "longitude", "accuracy", "timestamp"];

  capture(event) {
    event.preventDefault();
    if (this.pending) return;
    if (!navigator.geolocation) return this.failure("This browser cannot provide location. Please use a phone with location enabled.");
    this.pending = true;
    this.buttonTarget.disabled = true;
    this.setState("locating", "Finding your worksite", "One fresh reading. Stay here a moment.", "Finding you…");
    this.statusTarget.textContent = "Getting a fresh, high-accuracy location…";
    navigator.geolocation.getCurrentPosition(position => {
      if (!this.element.isConnected) return;
      this.latitudeTarget.value = position.coords.latitude;
      this.longitudeTarget.value = position.coords.longitude;
      this.accuracyTarget.value = position.coords.accuracy;
      this.timestampTarget.value = position.timestamp;
      this.setState("submitting", "Location received", `${position.coords.latitude.toFixed(5)}, ${position.coords.longitude.toFixed(5)} · ±${Math.ceil(position.coords.accuracy)} m`, "Checking your punch…");
      this.statusTarget.textContent = `Checking the worksite (reported accuracy ±${Math.ceil(position.coords.accuracy)} m)…`;
      // The server verifies the boundary and assigns the punch timestamp.
      // A received GPS fix is never presented as an accepted clock-in.
      HTMLFormElement.prototype.submit.call(this.element);
    }, error => {
      const messages = {
        1: "Location permission was denied. Enable it for 313.cash, then retry.",
        2: "Location is unavailable. Move to a clearer signal and retry.",
        3: "Location timed out. No clock-in was recorded. Please retry."
      };
      this.failure(messages[error.code] || "Location could not be verified. Please retry.");
    }, { enableHighAccuracy: true, maximumAge: 0, timeout: 20000 });
  }

  clockOut(event) {
    event.preventDefault();
    if (this.pending) return;
    this.pending = true;
    this.buttonTarget.disabled = true;
    this.setState("submitting", "Closing your shift", "Your timecard is being submitted for review.", "Wrapping it up…");
    this.statusTarget.textContent = "Saving your clock-out and actual unpaid break…";
    HTMLFormElement.prototype.submit.call(this.element);
  }

  failure(message) {
    if (!this.element.isConnected) return;
    this.pending = false;
    this.buttonTarget.disabled = false;
    this.setState("error", "Location needs a hand", "No clock-in recorded. You can try again.", "Try clock-in again");
    this.statusTarget.textContent = message;
  }

  setState(state, heading, reading, button) {
    this.element.setAttribute?.("data-timeclock-state", state);
    this.element.setAttribute?.("aria-busy", String(this.pending));
    if (this.hasLocationHeadingTarget) this.locationHeadingTarget.textContent = heading;
    if (this.hasReadingTarget) this.readingTarget.textContent = reading;
    if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = button;
  }
}
